<div class="dt-main">
  <app-sidebar></app-sidebar>
  <div class="dt-content-wrapper overflow-y-scroll">
    <div class="dt-content">
      <div class="col-md-12 spc-padding">
        <h2 class="pageHeading">
          <span class="main-chevron">
            <svg
              width="10"
              height="15"
              viewBox="0 0 10 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.666748 7.5L7.91675 14.75L9.6205 13.0463L4.08633 7.5L9.6205 1.95375L7.91675 0.250003L0.666748 7.5Z"
                fill="#0D1758"
              ></path>
            </svg>
          </span>
          Reports
        </h2>
        <div class="bg-lightgrey overflow-y-scroll">
          <h3 class="subheading">Alerts</h3>
          <div class="row">
            <!-- <div class="col-md-3 mb-4">
              <div class="card border-radius5 p-3">
                <div class="cardupper">
                  <img src="assets/images/onoffalert.png" alt="onoffalert"/>
                </div>
                <div class="cardfoot border-top">
                  <a href="javascript: void(0);" >On/Off Alerts <img src="assets/images/expand_right.svg" alt="arrow"/></a>
                </div>
              </div>
            </div> -->

            <!-- <div class="col-md-3 mb-4">
              <div class="card border-radius5 p-3">
                <div class="cardupper">
                  <img src="assets/images/consumption.png" alt="consumption"/>
                </div>
                <div class="cardfoot border-top">
                  <a href="javascript: void(0);" >Consumption <img src="assets/images/expand_right.svg" alt="arrow"/></a>
                </div>
              </div>
            </div> -->
            <!--
            <div class="col-md-3 mb-4">
              <div class="card border-radius5 p-3">
                <div class="cardupper">
                  <img src="assets/images/equipment.png" alt="equipment"/>
                </div>
                <div class="cardfoot border-top">
                  <a href="javascript: void(0);" >Equipment <img src="assets/images/expand_right.svg" alt="arrow"/></a>
                </div>
              </div>
            </div> -->

            <div class="col-md-3 mb-4">
              <div class="card border-radius5 p-3">
                <div class="cardupper">
                  <img
                    src="assets/images/connectivity.png"
                    alt="connectivity"
                  />
                </div>
                <div class="cardfoot border-top">
                  <a routerLink="/alertreports/connectivity">
                    Connectivity
                    <img
                      src="assets/images/expand_right.svg"
                      alt="arrow"
                  /></a>
                </div>
              </div>
            </div>

            <div class="col-md-12 mt-2">
              <h3 class="subheading">Reports</h3>
            </div>

            <div class="col-md-3">
              <div class="card border-radius5 p-3">
                <div class="cardupper">
                  <img
                    src="assets/images/exportdata.png"
                    alt="exportdata"
                  />
                </div>
                <div class="cardfoot border-top">
                  <a
                    href="javascript: void(0);"
                    (click)="openExportDataModal()"
                    >Export Data
                    <img
                      src="assets/images/expand_right.svg"
                      alt="arrow"
                  /></a>
                  <div
                    class="modal"
                    id="energyReport"
                    tabindex="-1"
                    role="dialog"
                    *ngIf="modal == 'exportData'"
                    style="display: block"
                  >
                    <div
                      class="modal-dialog"
                      role="document"
                    >
                      <div class="modal-content">
                        <div class="modal-header">
                          <h4 class="modal-title">Export Data</h4>
                          <button
                            type="button"
                            class="btn"
                            (click)="closePopup()"
                          >
                            <img
                              src="assets/images/cancel.svg"
                              alt="arrow"
                            />
                          </button>
                        </div>
                        <div class="modal-body">
                          <div>
                            <div *ngIf="!isShow">
                              <a
                                href="javascript:void(0);"
                                (click)="toggleDisplay2()"
                                ><h3>
                                  <span class="main-chevron"
                                    ><svg
                                      _ngcontent-yjq-c111=""
                                      width="10"
                                      height="15"
                                      viewBox="0 0 10 15"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        _ngcontent-yjq-c111=""
                                        d="M0.666748 7.5L7.91675 14.75L9.6205 13.0463L4.08633 7.5L9.6205 1.95375L7.91675 0.250003L0.666748 7.5Z"
                                        fill="#0D1758"
                                      ></path></svg
                                  ></span>
                                  MCC’s/Panels & Circuits
                                </h3></a
                              >
                            </div>
                          </div>
                          <div class="bg-lightgrey energy-report-modal">
                            <div class="energy-report-selection">
                              <div class="ers-left">
                                <h5>Download Raw Excel Data</h5>

                                <div class="col-md-6">
                                  <div
                                    class="report-selection-container"
                                    style="margin-left: 0%; margin-top: 0%"
                                  >
                                    <div class="range-selector-buttons">
                                      <div
                                        class="range-selector-button"
                                        id="rangeSelectorDay"
                                        (click)="rangeSelected($event)"
                                        style="width: 50%"
                                      >
                                        Day
                                      </div>
                                      <!-- <div class="range-selector-button" id="rangeSelectorWeek"  (click)="rangeSelected($event)">Week</div> -->
                                      <div
                                        class="range-selector-button selected"
                                        id="rangeSelectorMonth"
                                        (click)="rangeSelected($event)"
                                        style="width: 50%"
                                      >
                                        Month
                                      </div>
                                    </div>

                                    <div
                                      class="range-selector"
                                      *ngIf="rangeSelectedMonth"
                                    >
                                      <div class="month-selector">
                                        <div
                                          class="left-button"
                                          (click)="selectPreviousMonth()"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="20"
                                            width="20"
                                            style="
                                              fill: white;
                                              transform: scale(0.6);
                                            "
                                          >
                                            <path
                                              d="m8 18-8-8 8-8 1.417 1.417L2.833 10l6.584 6.583Z"
                                            />
                                          </svg>
                                        </div>
                                        <p
                                          class="selected-month prevent-select"
                                        >
                                          {{
                                            energyReportSelectedMonth
                                              | date : 'LLLL YYYY'
                                          }}
                                        </p>
                                        <div
                                          class="right-button"
                                          (click)="selectNextMonth()"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="20"
                                            width="20"
                                            style="
                                              fill: white;
                                              transform: scale(0.6)
                                                rotate(180deg);
                                            "
                                          >
                                            <path
                                              d="m8 18-8-8 8-8 1.417 1.417L2.833 10l6.584 6.583Z"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="range-selector"
                                      *ngIf="rangeSelectedDay"
                                    >
                                      <div class="month-selector">
                                        <div
                                          class="left-button"
                                          (click)="selectPreviousDay()"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="20"
                                            width="20"
                                            style="
                                              fill: white;
                                              transform: scale(0.6);
                                            "
                                          >
                                            <path
                                              d="m8 18-8-8 8-8 1.417 1.417L2.833 10l6.584 6.583Z"
                                            />
                                          </svg>
                                        </div>
                                        <p
                                          class="selected-month prevent-select"
                                        >
                                          {{
                                            energyReportSelectedDay
                                              | date : 'dd MMM yyyy'
                                          }}
                                        </p>
                                        <div
                                          class="right-button"
                                          (click)="selectNextDay()"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="20"
                                            width="20"
                                            style="
                                              fill: white;
                                              transform: scale(0.6)
                                                rotate(180deg);
                                            "
                                          >
                                            <path
                                              d="m8 18-8-8 8-8 1.417 1.417L2.833 10l6.584 6.583Z"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <br />
                                <div class="row">
                                  <div class="col-md-6">
                                    <b class="units">Units:</b>
                                    <div class="frame-parent">
                                      <div
                                        class="radio-button-checked-parent"
                                        style="display: flex"
                                      >
                                        <input
                                          type="radio"
                                          id="watts"
                                          name="watts"
                                          value="watts"
                                          (click)="unitEdit($event)"
                                          [checked]="wattSelection"
                                        />
                                        <label for="watts">Watts</label>
                                      </div>
                                      <div
                                        class="radio-button-checked-parent"
                                        style="display: flex"
                                      >
                                        <input
                                          type="radio"
                                          id="volts"
                                          name="volts"
                                          value="volts"
                                          (click)="unitEdit($event)"
                                          [checked]="voltSelection"
                                        />
                                        <label for="volts">Volts/Amps</label>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-md-6">
                                    <b class="units">Intervals:</b>
                                    <div class="frame-parent">
                                      <div *ngIf="rangeSelectedDay">
                                        <div
                                          class="radio-button-checked-parent"
                                          style="display: flex"
                                        >
                                          <input
                                            type="radio"
                                            id="day1m"
                                            name="interval"
                                            value="1m"
                                            (click)="intervalEdit($event)"
                                          />
                                          <label for="day1m">Minute</label>
                                        </div>
                                        <div
                                          class="radio-button-checked-parent"
                                          style="display: flex"
                                        >
                                          <input
                                            type="radio"
                                            id="day60m"
                                            name="interval"
                                            value="60m"
                                            (click)="intervalEdit($event)"
                                            checked
                                          />
                                          <label for="day60m">Hourly</label>
                                        </div>
                                      </div>
                                      <div *ngIf="rangeSelectedMonth">
                                        <div
                                          class="radio-button-checked-parent"
                                          style="display: flex"
                                        >
                                          <input
                                            type="radio"
                                            id="month1D"
                                            name="interval"
                                            value="1D"
                                            (click)="intervalEdit($event)"
                                          />
                                          <label for="month1D">Daily</label>
                                        </div>
                                        <div
                                          class="radio-button-checked-parent"
                                          style="display: flex"
                                        >
                                          <input
                                            type="radio"
                                            id="month60m"
                                            name="interval"
                                            value="60m"
                                            (click)="intervalEdit($event)"
                                            checked
                                          />
                                          <label for="month60m">Hourly</label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="units-parent">
                                  <b class="units">Generate for:</b>
                                  <div
                                    class="frame-parent"
                                    style="display: block"
                                  >
                                    <div
                                      class="radio-button-checked-parent"
                                      style="display: flex"
                                    >
                                      <input
                                        type="radio"
                                        id="allPanels"
                                        name="allPanels"
                                        value="allPanels"
                                        (click)="generatorEdit($event)"
                                        [checked]="allPanelsSelection"
                                      />
                                      <label for="allPanels"
                                        >All Panels (no circuits)</label
                                      >
                                    </div>
                                    <div
                                      class="radio-button-checked-parent"
                                      style="display: flex"
                                    >
                                      <input
                                        type="radio"
                                        id="allPanelsWithCircuits"
                                        name="allPanelsWithCircuits"
                                        value="allPanelsWithCircuits"
                                        (click)="generatorEdit($event)"
                                        [checked]="
                                          allPanelsWithCircuitsSelection
                                        "
                                      />
                                      <label for="allPanelsWithCircuits"
                                        >All Panels (with circuits)</label
                                      >
                                    </div>
                                    <div
                                      class="radio-button-checked-parent"
                                      style="display: flex"
                                    >
                                      <input
                                        type="radio"
                                        id="singlePanelsWithCircuits"
                                        name="singlePanelsWithCircuits"
                                        value="singlePanelsWithCircuits"
                                        (click)="generatorEdit($event)"
                                        [checked]="
                                          singlePanelsWithCircuitsSelection
                                        "
                                      />
                                      <label for="singlePanelsWithCircuits"
                                        >Single Panel (with circuits)</label
                                      >
                                    </div>
                                    <div>
                                      <select
                                        class="selector-item"
                                        *ngIf="
                                          singlePanelsWithCircuitsSelection
                                        "
                                        [(ngModel)]="selectedPanel"
                                      >
                                        <option
                                          [ngValue]="null"
                                          disabled
                                        >
                                          Select Panel
                                        </option>
                                        <option
                                          *ngFor="let panel of panels"
                                          [ngValue]="panel.panel_id"
                                        >
                                          {{ panel.panel_name }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="ers-right"
                                style="
                                  width: 50%;
                                  height: 70%;
                                  overflow: hidden;
                                "
                              >
                                <img
                                  src="assets/images/download_report.png"
                                  alt="energy-report"
                                  style="width: 170%"
                                />
                                <br />
                                <br />
                                <a
                                  href="javascript: void(0);"
                                  (click)="downloadRawData()"
                                  class="btn btn-primary generate-report-button"
                                  >Generate Report</a
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="col-md-3">
              <div class="card border-radius5 p-3">
                <div class="cardupper">
                  <img
                    src="assets/images/schedule.png"
                    alt="Schedules"
                  />
                </div>
                <div class="cardfoot border-top">
                  <a
                    href="javascript: void(0);"
                    (click)="openScheduleModal()"
                    >Schedules
                    <img
                      src="assets/images/expand_right.svg"
                      alt="arrow"
                  /></a>

                  <div
                    class="modal"
                    id="schedule"
                    tabindex="-1"
                    role="dialog"
                    *ngIf="modal == 'schedule'"
                    style="display: block"
                  >
                    <div
                      class="modal-dialog"
                      role="document"
                    >
                      <div class="modal-content">
                        <div class="modal-header">
                          <h4 class="modal-title">Schedules</h4>
                          <button
                            type="button"
                            class="btn"
                            (click)="closePopup()"
                          >
                            <img
                              src="assets/images/cancel.svg"
                              alt="arrow"
                            />
                          </button>
                        </div>
                        <div class="modal-body">
                          <div class="modalheadingbox">
                            <div *ngIf="!isShow">
                              <a
                                href="javascript:void(0);"
                                (click)="toggleDisplay2()"
                                ><h3>
                                  <span class="main-chevron"
                                    ><svg
                                      _ngcontent-yjq-c111=""
                                      width="10"
                                      height="15"
                                      viewBox="0 0 10 15"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        _ngcontent-yjq-c111=""
                                        d="M0.666748 7.5L7.91675 14.75L9.6205 13.0463L4.08633 7.5L9.6205 1.95375L7.91675 0.250003L0.666748 7.5Z"
                                        fill="#0D1758"
                                      ></path></svg
                                  ></span>
                                  MCC’s/Panels & Circuits
                                </h3></a
                              >
                            </div>
                          </div>
                          <div class="bg-lightgrey p-20">
                            <div
                              class="schedulebx"
                              *ngIf="isShow"
                            >
                              <h5>Schedules</h5>
                              <ul class="listing_mod">
                                <li>
                                  <a
                                    href="javascript: void(0);"
                                    (click)="toggleDisplay()"
                                    >MCCs Panels & Circuits
                                    <img
                                      _ngcontent-ecb-c111=""
                                      src="assets/images/expand_right.svg"
                                      alt="arrow"
                                  /></a>
                                </li>
                                <li>
                                  <a href="javascript: void(0);"
                                    >Lighting
                                    <img
                                      _ngcontent-ecb-c111=""
                                      src="assets/images/expand_right.svg"
                                      alt="arrow"
                                  /></a>
                                </li>
                                <li>
                                  <a href="javascript: void(0);"
                                    >HVAC
                                    <img
                                      _ngcontent-ecb-c111=""
                                      src="assets/images/expand_right.svg"
                                      alt="arrow"
                                  /></a>
                                </li>
                                <li>
                                  <a href="javascript: void(0);"
                                    >Boiler & DHW
                                    <img
                                      _ngcontent-ecb-c111=""
                                      src="assets/images/expand_right.svg"
                                      alt="arrow"
                                  /></a>
                                </li>
                                <li>
                                  <a href="javascript: void(0);"
                                    >Pumps & Motors
                                    <img
                                      _ngcontent-ecb-c111=""
                                      src="assets/images/expand_right.svg"
                                      alt="arrow"
                                  /></a>
                                </li>
                              </ul>
                            </div>
                            <div
                              class="panelCircuit"
                              *ngIf="!isShow"
                            >
                              <div class="row">
                                <div class="col-md-6">
                                  <h5>MCC’s/Panels & Circuits</h5>
                                  <div class="imgInline">
                                    <img
                                      src="assets/images/thumb_electrical-panel-open_2.png"
                                      alt="thumb_electrical-panel-open_2"
                                      class="img-fluid"
                                    /><img
                                      src="assets/images/thumb_MCC_Unit.png"
                                      alt="thumb_MCC_Unit"
                                      class="img-fluid"
                                    />
                                  </div>
                                  <p>
                                    Generate a schedule report of your
                                    facilities MCC units, electrical panels and
                                    circuits.
                                  </p>
                                </div>
                                <div class="col-md-6">
                                  <div class="imgbx">
                                    <img
                                      src="assets/images/doc-pageschedule.png"
                                      alt="arrow"
                                      class="img-fluid"
                                    />
                                  </div>
                                  <a
                                    href="javascript: void(0);"
                                    (click)="downloadPanelScheduleReport()"
                                    class="btn btn-primary"
                                    >Generate Report</a
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="col-md-3">
              <div class="card border-radius5 p-3">
                <div class="cardupper">
                  <img
                    src="assets/images/energyReportBlank.png"
                    alt="energy-report"
                  />
                </div>
                <div class="cardfoot border-top">
                  <a
                    href="javascript: void(0);"
                    (click)="openEnergyReportModal()"
                    >Energy Report
                    <img
                      src="assets/images/expand_right.svg"
                      alt="arrow"
                  /></a>

                  <div
                    class="modal"
                    id="energyReport"
                    tabindex="-1"
                    role="dialog"
                    *ngIf="modal == 'energyReport'"
                    style="display: block"
                  >
                    <div
                      class="modal-dialog"
                      role="document"
                    >
                      <div class="modal-content">
                        <div class="modal-header">
                          <h4 class="modal-title">{{
                            energyReportTab == 'energyReport'
                              ? 'Energy Report'
                              : 'Top Energy Consumers'
                          }}</h4>
                          <button
                            type="button"
                            class="btn"
                            (click)="closePopup()"
                          >
                            <img
                              src="assets/images/cancel.svg"
                              alt="arrow"
                            />
                          </button>
                        </div>
                        <div class="modal-body">
                          <div>
                            <svg style="margin-right: 15px;"  (click)="energyReportTabClicked('energyReport')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path [ngClass]="energyReportTab == 'energyReport' ? 'selected' : ''" fill-rule="evenodd" clip-rule="evenodd" d="M2 5.85596C2 3.78438 3.67935 2.10503 5.75094 2.10503H15.4134C15.8277 2.10503 16.1635 2.4409 16.1635 2.85521C16.1635 3.26953 15.8277 3.6054 15.4134 3.6054H5.75094C4.50799 3.6054 3.50038 4.61301 3.50038 5.85596V18.2491C3.50038 19.492 4.50799 20.4996 5.75094 20.4996H18.2491C19.492 20.4996 20.4996 19.492 20.4996 18.2491V8.66167C20.4996 8.24735 20.8355 7.91148 21.2498 7.91148C21.6641 7.91148 22 8.24735 22 8.66167V18.2491C22 20.3206 20.3206 22 18.2491 22H5.75094C3.67935 22 2 20.3206 2 18.2491V5.85596ZM18.3028 6.7478C18.6306 7.00118 18.6909 7.47233 18.4375 7.80013L15.4334 11.6864C14.6095 12.7523 13.037 12.8526 12.0843 11.9C11.7687 11.5843 11.2468 11.6207 10.978 11.9771L8.04528 15.8651C7.79578 16.1959 7.32538 16.2618 6.99461 16.0123C6.66384 15.7628 6.59795 15.2924 6.84745 14.9616L9.78014 11.0736C10.5978 9.98954 12.1851 9.87891 13.1453 10.839C13.4585 11.1522 13.9755 11.1193 14.2464 10.7688L17.2504 6.88254C17.5038 6.55474 17.975 6.49441 18.3028 6.7478Z" fill="#AFB6CE"/>
                              <path [ngClass]="energyReportTab == 'energyReport' ? 'selected' : ''" d="M21.91 3.95049C21.91 5.02771 21.0367 5.90098 19.9595 5.90098C18.8823 5.90098 18.009 5.02771 18.009 3.95049C18.009 2.87326 18.8823 2 19.9595 2C21.0367 2 21.91 2.87326 21.91 3.95049Z" fill="#AFB6CE"/>
                              </svg>
                              <svg (click)="energyReportTabClicked('circuitEnergyReport')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path [ngClass]="energyReportTab == 'energyReport' ? '' : 'selected'" d="M8.75982 4.34945C8.66292 4.24479 8.54544 4.16128 8.41474 4.10417C8.28404 4.04706 8.14295 4.01758 8.00032 4.01758C7.85769 4.01758 7.7166 4.04706 7.5859 4.10417C7.4552 4.16128 7.33772 4.24479 7.24082 4.34945L4.24082 7.84945C4.15533 7.94919 4.09032 8.06479 4.04951 8.18966C4.00869 8.31452 3.99287 8.4462 4.00295 8.57717C4.01302 8.70815 4.0488 8.83586 4.10823 8.95301C4.16766 9.07016 4.24958 9.17446 4.34932 9.25995C4.44906 9.34544 4.56466 9.41045 4.68952 9.45127C4.81439 9.49208 4.94606 9.5079 5.07704 9.49783C5.20802 9.48775 5.33573 9.45198 5.45288 9.39255C5.57003 9.33312 5.67433 9.25119 5.75982 9.15145L7.00032 7.70395V17.0005C7.00032 17.2657 7.10568 17.52 7.29321 17.7076C7.48075 17.8951 7.7351 18.0005 8.00032 18.0005C8.26554 18.0005 8.51989 17.8951 8.70743 17.7076C8.89496 17.52 9.00032 17.2657 9.00032 17.0005V7.70395L10.2408 9.15145C10.4135 9.35289 10.6591 9.47748 10.9236 9.49783C11.1881 9.51818 11.4499 9.43261 11.6513 9.25995C11.8528 9.0873 11.9773 8.84169 11.9977 8.57717C12.018 8.31265 11.9325 8.05089 11.7598 7.84945L8.75982 4.34945ZM19.6513 14.741C19.45 14.5684 19.1883 14.4828 18.9239 14.5032C18.6594 14.5235 18.4139 14.6481 18.2413 14.8495L17.0003 16.297V7.00045C17.0003 6.73524 16.895 6.48088 16.7074 6.29335C16.5199 6.10581 16.2655 6.00045 16.0003 6.00045C15.7351 6.00045 15.4808 6.10581 15.2932 6.29335C15.1057 6.48088 15.0003 6.73524 15.0003 7.00045V16.297L13.7598 14.8495C13.6743 14.7497 13.57 14.6678 13.4529 14.6084C13.3357 14.5489 13.208 14.5132 13.077 14.5031C12.9461 14.493 12.8144 14.5088 12.6895 14.5496C12.5647 14.5905 12.4491 14.6555 12.3493 14.741C12.2496 14.8264 12.1677 14.9307 12.1082 15.0479C12.0488 15.165 12.013 15.2928 12.0029 15.4237C11.9929 15.5547 12.0087 15.6864 12.0495 15.8113C12.0903 15.9361 12.1553 16.0517 12.2408 16.1515L15.2408 19.6515C15.3347 19.7611 15.4512 19.8491 15.5823 19.9094C15.7134 19.9697 15.856 20.0009 16.0003 20.0009C16.1446 20.0009 16.2872 19.9697 16.4183 19.9094C16.5494 19.8491 16.6659 19.7611 16.7598 19.6515L19.7598 16.1515C19.9324 15.9501 20.0179 15.6884 19.9976 15.424C19.9772 15.1596 19.8527 14.9135 19.6513 14.741Z" fill="#AFB6CE"/>
                                </svg>
                          </div>
                          <div style="margin-top:10px">
                            <div *ngIf="!isShow">
                              <a
                                href="javascript:void(0);"
                                (click)="toggleDisplay2()"
                                ><h3>
                                  <span class="main-chevron"
                                    ><svg
                                      _ngcontent-yjq-c111=""
                                      width="10"
                                      height="15"
                                      viewBox="0 0 10 15"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        _ngcontent-yjq-c111=""
                                        d="M0.666748 7.5L7.91675 14.75L9.6205 13.0463L4.08633 7.5L9.6205 1.95375L7.91675 0.250003L0.666748 7.5Z"
                                        fill="#0D1758"
                                      ></path></svg
                                  ></span>
                                  MCC’s/Panels & Circuits
                                </h3></a
                              >
                            </div>
                          </div>
                          <div class="bg-lightgrey energy-report-modal">
                            <div class="energy-report-selection">
                              <div class="ers-left">
                                <h5>
                                  {{
                                    energyReportTab == 'energyReport'
                                      ? 'Generate a energy usage report with analysis'
                                      : 'A report showing top circuit usage for the day'
                                  }}
                                </h5>

                                <div class="report-selection-container">
                                  <div class="range-selector-buttons">
                                    <div
                                      class="range-selector-button"
                                      id="rangeSelectorDay"
                                      (click)="rangeSelected($event)"
                                      style="width: 50%"
                                    >
                                      Day
                                    </div>
                                    <!-- <div class="range-selector-button" id="rangeSelectorWeek"  (click)="rangeSelected($event)">Week</div> -->
                                    <div
                                      class="range-selector-button selected"
                                      id="rangeSelectorMonth"
                                      (click)="rangeSelected($event)"
                                      style="width: 50%"
                                    >
                                      Month
                                    </div>
                                  </div>

                                  <div
                                    class="range-selector"
                                    *ngIf="rangeSelectedMonth"
                                  >
                                    <div class="month-selector">
                                      <div
                                        class="left-button"
                                        (click)="selectPreviousMonth()"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          height="20"
                                          width="20"
                                          style="
                                            fill: white;
                                            transform: scale(0.6);
                                          "
                                        >
                                          <path
                                            d="m8 18-8-8 8-8 1.417 1.417L2.833 10l6.584 6.583Z"
                                          />
                                        </svg>
                                      </div>
                                      <p class="selected-month prevent-select">
                                        {{
                                          energyReportSelectedMonth
                                            | date : 'LLLL YYYY'
                                        }}
                                      </p>
                                      <div
                                        class="right-button"
                                        (click)="selectNextMonth()"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          height="20"
                                          width="20"
                                          style="
                                            fill: white;
                                            transform: scale(0.6) rotate(180deg);
                                          "
                                        >
                                          <path
                                            d="m8 18-8-8 8-8 1.417 1.417L2.833 10l6.584 6.583Z"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    class="range-selector"
                                    *ngIf="rangeSelectedDay"
                                  >
                                    <div class="month-selector">
                                      <div
                                        class="left-button"
                                        (click)="selectPreviousDay()"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          height="20"
                                          width="20"
                                          style="
                                            fill: white;
                                            transform: scale(0.6);
                                          "
                                        >
                                          <path
                                            d="m8 18-8-8 8-8 1.417 1.417L2.833 10l6.584 6.583Z"
                                          />
                                        </svg>
                                      </div>
                                      <p class="selected-month prevent-select">
                                        {{
                                          energyReportSelectedDay
                                            | date : 'dd MMM yyyy'
                                        }}
                                      </p>
                                      <div
                                        class="right-button"
                                        (click)="selectNextDay()"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          height="20"
                                          width="20"
                                          style="
                                            fill: white;
                                            transform: scale(0.6) rotate(180deg);
                                          "
                                        >
                                          <path
                                            d="m8 18-8-8 8-8 1.417 1.417L2.833 10l6.584 6.583Z"
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>


                                  <div class="report-selection-label">
                                    <div>

                                      <input
                                      type="checkbox"
                                      class="form-check-input"
                                      id="exampleCheckbox"
                                      [(ngModel)]="energyCheckboxModel"
                                      style="margin-right: 10px;"
                                    />
                                      <label class="form-check-label" for="exampleCheckbox">
                                        Generate Daily
                                      </label>
                                      <br>
                                      <label style="font-size: smaller;">a daily report of the previous days usage will be emailed to you</label>
                                    </div>
                                </div>
                                  </div>
                                  
                              </div>
                              <!-- <div class="ers-right" style="width: 272px;">
                                <img src="assets/images/energyReportBlank.png" alt="energy-report" style="width: 100%;"/>
                              </div> -->
                              <div
                                class="ers-right"
                                style="position: relative; width: 272px"
                              >
                                <img
                                  src="{{ company?.image ?? '' }}"
                                  *ngIf="company?.image"
                                  style="
                                    position: absolute;
                                    top: 6%;
                                    right: 7%;
                                    height: 80px;
                                  "
                                />

                                <img
                                  src="assets/images/energyReportBlank.png"
                                  alt="energy-report"
                                  style="width: 100%"
                                />
                                <div
                                  style="
                                    position: absolute;
                                    top: 36%;
                                    left: 10.5%;
                                    font-size: small;
                                    color: rgb(32, 32, 89);
                                  "
                                >
                                  <p>
                                    {{
                                      energyReportSelectedMonth
                                        | date : 'LLLL YYYY'
                                    }}
                                  </p>
                                </div>
                                <div
                                  style="
                                    position: absolute;
                                    top: 64%;
                                    left: 0%;
                                    margin-left: 39%;
                                    font-size: small;
                                    transform: translate(-50%, -50%);
                                    color: rgb(32, 32, 89);
                                  "
                                >
                                  <img
                                    [src]="
                                      currentBuilding.image ||
                                      currentBuilding.facility.image ||
                                      currentBuilding.facility.custom_image
                                    "
                                    alt=""
                                    style="width: 50%"
                                  />
                                  <p
                                    style="
                                      margin: 0;
                                      padding-left: 7%;
                                      font-size: small;
                                    "
                                  >
                                    {{ currentBuilding.description }}
                                  </p>
                                  <p
                                    style="
                                      margin: 0;
                                      padding-left: 7%;
                                      font-size: xx-small;
                                    "
                                  >
                                    {{ currentBuilding.address_line_1 }}
                                  </p>
                                </div>
                                <div>
                                  <a
                                href="javascript: void(0);"
                                (click)="emailEnergyReport()"
                                class="btn btn-primary generate-report-button"
                                *ngIf="!isGenerating && !isError"
                                >Email Report</a>

                              <a
                                href="javascript: void(0);"
                                class="btn btn-primary generate-report-button"
                                style="
                                  opacity: 0.9;
                                  pointer-events: none;
                                "
                                *ngIf="isGenerating && !isError">
                                <div class="loader"></div>
                                Emailing Report</a>

                              <a
                                href="javascript: void(0);"
                                (click)="emailEnergyReport()"
                                class="btn btn-primary generate-report-button"
                                style="
                                  background-color: red;
                                  border-color: red;
                                "
                                *ngIf="!isGenerating && isError"
                              >
                                Try Again
                              </a>

                              <a
                                href="javascript: void(0);"
                                class="btn btn-primary generate-report-button"
                                style="
                                  opacity: 0.9;
                                  pointer-events: none;
                                "
                                *ngIf="isGenerating && !isError">
                                <div class="loader"></div>
                                Generating Report</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="col-md-3">
              <div class="card border-radius5 p-3">
                <div class="cardupper">
                  <img
                    src="assets/images/asset-health.png"
                    alt="asset-health"
                  />
                </div>
                <div class="cardfoot border-top">
                  <a href="javascript: void(0);"
                    >Asset Health
                    <img
                      src="assets/images/expand_right.svg"
                      alt="arrow"
                  /></a>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
